import { Component, EventEmitter, HostListener, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'core-ui-dialog-base',
  templateUrl: 'dialog-base.component.html',
  styleUrls: ['dialog-base.component.scss'],
  imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule, NgClass]
})
export class DialogBaseComponent {
  @Input() public title: string;
  @Input() public button: string;
  @Input() public disabled = false;
  @Input() public hideHeader = false;
  @Input() public hideFooter = false;
  @Input() public cancelButton = false;
  @Input() public hideCloseIcon = false;
  @Output() public buttonClick = new EventEmitter<undefined>();

  public buttonClicked(): void {
    this.buttonClick.emit();
  }

  @HostListener('keydown.enter', ['$event'])
  public onEnterKey(): void {
    if (!this.disabled) {
      this.buttonClicked();
    }
  }
}
